module.exports = __webpack_public_path__ + "img/card-guideline-right.255f2685.svg";